<div
  [pTooltip]="content"
  [tooltipPosition]="position"
  [escape]="false"
  [tooltipOptions]="tooltipOptions"
  class="{{ styleClass }}"
  [tooltipStyleClass]="
    tooltipStyleClass ? 'm-tooltip ' + tooltipStyleClass : 'm-tooltip'
  ">
  <ng-content></ng-content>
</div>
